import request from 'services/axios'

export const getTransactions = async (pageParam: number) => {
    const { data }: { data: IDashboardTransactions } = await request.get(
        `/api/v1/payment/transactions/?cursor=${pageParam}`
    )
    return data
}
